var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "vue-need-bootstrap h100" }, [
    _c("div", { staticClass: "auth-background" }, [
      _c(
        "div",
        {
          staticClass: "auth-content",
          class: { "with-pitch": !!_setup.slot.pitch },
        },
        [
          _setup.slot.pitch
            ? _c("div", { staticClass: "auth-pitch" }, [_vm._t("pitch")], 2)
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "auth-card" }, [_vm._t("default")], 2),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }